import {FlyingBubble} from "js/Elements/BubbleFlyingBehaviour";

export class SimulationBubble implements FlyingBubble {
  onCollision = new Phaser.Signal();
  onWallBounce = new Phaser.Signal();

  x = 0;
  y = 0;
  vel = { x: 0, y: 0 };
  cell = { x: 0, y : 0 };
  prevCell= { x: 0, y : 0 };
  collCircle: Phaser.Circle = new Phaser.Circle(0, 0, 25);
  public bubbleType = 0;

  public copyFrom(bubble: FlyingBubble) {
    this.x = bubble.x;
    this.y = bubble.y;
    bubble.collCircle.clone(bubble.collCircle);
    this.cell.x = bubble.cell.x;
    this.cell.y = bubble.cell.y;
    this.prevCell.x = bubble.prevCell.x;
    this.prevCell.y = bubble.prevCell.y;
    this.vel.x = bubble.vel.x;
    this.vel.y = bubble.vel.y;
  }
}
